<div class="si-loader-container">
  <kendo-loader type="converging-spinner"></kendo-loader>
</div>
